<template>
  <div class="video-wrapper">
    <video
      ref="videoRef"
      :src="url"
      :controls="!disable && isPlayed"
      :autoplay="!disable && autoplay"
      :muted="!disable && muted"
      :poster="poster"
      style="vertical-align: middle;"
      @pause="handlePause"
    ></video>
    <template v-if="!isPlayed">
      <div class="video-mask"  @click="onPlay">
        <!-- 播放按钮 -->
        <div class="video-play-btn">
          <i class="el-icon-video-play"></i>
          <span></span>
        </div>
      </div>
    </template>
  </div>
</template>


<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: true
    },
    poster: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isPlayed: false,
      isPlaying: false,
    }
  },

  mounted() {

  },

  methods: {
    // 自定义播放按钮点击回调
    onPlay() {
      if (this.disable) return
      console.dir(this.$refs.videoRef)
      this.isPlayed = true
      this.isPlaying = true
      this.$refs.videoRef.play()
    },


    // 视频暂停事件回调
    handlePause() {
      this.isPlaying = false
    },
  }
}
</script>



<style scoped>
.video-wrapper {
  width: 100%;
  position: relative;
  margin: auto;
}

video {
  width: 100%;
  height: auto;
  max-height: 65vh;
}

.video-play-btn {
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: rgba(255, 255, 255, 0.5);
  font-size: 50px;
  cursor: pointer;
}

.video-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  
}
</style>


// WEBPACK FOOTER //
// src/components/CustomVideo.vue